import { FC, Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import Input from 'shared/Input/Input';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import { useTranslation } from 'react-i18next';

interface TimeModalProps {
  isOpen: boolean;
  time: string;
  closeModal: (time: string) => void;
}

const TimeModal: FC<TimeModalProps> = ({
  isOpen,
  time,
  closeModal,
}) => {

    const [text, setText] = useState<string>(time || "");

    const { t, ready } = useTranslation("translation");

    if (!ready) {
        return null; // Wait for translations to be ready
    }

    const handleCloseModal = () => {
        if (closeModal) {
            closeModal(text);
        } else {
            console.warn("NotesModal: closeModal function is not provided");
        }
    };

    return (
        <>
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog as="div" onClose={() => null}>
            <Transition.Child
                as={Fragment}
                enter="transition-opacity duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-300"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30" />
            </Transition.Child>

            <Transition.Child
                as={Fragment}
                enter="transition ease-out duration-300"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition ease-in duration-200"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
            >
                <div className="fixed inset-0 flex items-center justify-center p-5 md:p-0">
                    <div className="bg-white rounded-lg p-10 flex items-start flex-col justify-center">
                        <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                            {t("translation:components.holidayPackageForm.timeModal.title")}
                        </Dialog.Title>
                        <div className="flex flex-col gap-4 my-4 w-full">
                            <p className="text-sm text-gray-500 break-words max-w-md">
                                {t("translation:components.holidayPackageForm.timeModal.description")}
                            </p>
                            <Input
                                placeholder={t("translation:components.holidayPackageForm.timeModal.inputPlaceholder")}
                                onChange={(e) => setText(e.target.value)}
                                value={text}
                            />
                        </div>
                        <div className="mt-4 flex flex-row gap-3">
                        <ButtonPrimary
                            onClick={handleCloseModal}
                        >
                            {t("translation:components.holidayPackageForm.timeModal.saveButton")}
                        </ButtonPrimary>
                        </div>
                    </div>
                </div>
            </Transition.Child>
            </Dialog>
        </Transition.Root>
        </>
    );
}

export default TimeModal;
